'use client';

import { AlertProps, Alert as MuiAlert } from '@mui/material';
import { forwardRef } from 'react';

import { CheckCircleRounded, Error, Info, Warning } from '../../icons';

import { AlertCloseIcon } from './styled';

export const Alert = forwardRef<HTMLDivElement, AlertProps>((props, ref) => {
  return (
    <MuiAlert
      ref={ref}
      components={{
        CloseIcon: (props) => <AlertCloseIcon {...props} fontSize="small" />,
      }}
      iconMapping={{
        info: <Info />,
        success: <CheckCircleRounded />,
        warning: <Warning />,
        error: <Error />,
      }}
      {...props}
    />
  );
});
